import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { WrapperComponent } from '@/app/components/projects/wrapper/wrapper.component';

// SERVICES START
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
// SERVICES END
@Component({
  standalone: true,
  imports: [CommonModule, WrapperComponent],
  selector: 'app-request-pqq-history',
  templateUrl: './requested-pqq-listing.component.html',
  styleUrls: ['./requested-pqq-listing.component.css'],
})
export class RequestedPqqListingComponent implements OnInit {
  pqqListing!: any;
  projectId: any;
  projectIdNew: any;
  projectName: string;
  private subscription: Subscription = new Subscription();
  projectIdentifier: string;
  constructor(
    private router: Router,
    private tenderingService: TenderingService,
    private projectsService: ProjectsService,
    private getProjectIdService: GetProjectIdService,
    private activeRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.projectId = this.getProjectIdService.getProjectId();
    this.getCurrentProjectPQQListing(); // Assign and process the data in getRiskRegisterData
    this.activeRoute.queryParams.subscribe((params) => {
      this.projectName = params['projectName'];
      this.projectIdentifier = params['projectIdentifier'];
    });
  }

  closeEoiSubmissions(eoi_id: any) {
    return this.projectsService.closeEOI(eoi_id).subscribe({
      next: (data: any) => {
        if (data) {
          this.getCurrentProjectPQQListing();
        }
      },
      error: (error) => {
        console.error('Error fetching projects:', error);
      },
    });
  }
  isCreate = false;
  currentDialog = 'PQQ';

  handleDialog() {
    this.isCreate = false;
  }

  getCurrentProjectPQQListing(): any {
    return this.tenderingService
      .getCurrentProjectPQQListing(this.projectId, 'pqq')
      .subscribe({
        next: (response: any) => {
          if (response?.data?.pqqs) {
            this.pqqListing = response.data.pqqs;
          }
        },
        error: (error) => {
          console.error('Error fetching projects:', error);
        },
      });
  }

  formatDate(dateString: string): string | null {
    if (!dateString) return null;
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Add leading zero
    const day = ('0' + date.getDate()).slice(-2); // Add leading zero

    return `${year}-${month}-${day}`;
  }

  openView(id: any) {
    this.tenderingService.setpqqId(id);
    this.router.navigate(['/applicant-individual-pqq-view', id],{
      queryParams:{
        projectIdentifier: this.projectIdentifier,
        projectName: this.projectName
      }
    });
  }
}
